<template>
  <div class="table-screes">
    <div class="screes-titel">
      <h2>筛选</h2>
      <img src="../../../../static/images/close.png" class="closeicon" @click="closeClick">
    </div>
    <div class="screes-warpper">
      <van-collapse v-model="activeName" accordion @change="getName()">
        <van-collapse-item name="1">
          <div slot="title">
            机构
            <div v-show="textShow" class='text'>{{showText}}</div>
          </div>
          <MyTreeSelect ref="treeSelect" :filterType="'branch'" :items="branchs" v-on:chooseData1='getData1' v-on:chooseData2='getData2'></MyTreeSelect>
        </van-collapse-item>
        <van-collapse-item :title="otherFiler.achievementName" name="2" class="inputBox">
          <van-cell-group>
            <van-field v-model="reachObj.reachMin" :placeholder="'最低('+otherFiler.achievementUnit+')'"  v-if="otherFiler.achievementUnit"/>
            <van-field v-model="reachObj.reachMin" :placeholder="'最低'"  v-else/>
          </van-cell-group>
          <span>---</span>
          <van-cell-group>
            <van-field v-model="reachObj.reachMax" :placeholder="'最高('+otherFiler.achievementUnit+')'"  v-if="otherFiler.achievementUnit"/>
            <van-field v-model="reachObj.reachMax" :placeholder="'最高'"  v-else/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="screes-footer">
      <button @click="clearSelectedBranchs">重置</button>
      <button @click="childClick">确定</button>
    </div>
  </div>

</template>

<script>
import MyTreeSelect from './MyTreeSelectOpe'
// import MyTreeSelect from './MyTreeSelect1'
// import axios from 'axios'
import { postAction, getAction } from '@/utils/api'
export default {
  name: 'TablesScreens',
  components: {
    MyTreeSelect
  },
  props: ['timeIndex', 'otherFiler', 'calendarData'],
  data () {
    return {
      TopHundredData: 1,
      childByValue: false,
      type: '',
      childValue: false,
      activeName: '0',
      branchs: [],
      products: [],
      rates: {},
      sliderValue: [],
      sliderTick: [],
      firstLevel: [], // 一级内容
      secondLevel: [], // 二级内容
      showText: '',
      textShow: false,
      postChannel: '',
      postKind: '',
      postTime: '',
      postQuota: '',
      showFlag: '',
      reachObj: {
        reachMin: '',
        reachMax: ''
      },
      compareObj: {
        compareMin: '',
        compareMax: ''
      },
      rateObj: {
        rateMin: '',
        rateMax: ''
      },
      ratioObj: {
        ratioMin: '',
        ratioMax: ''
      },
      itemButText: []
    }
  },
  methods: {
    changeTopHundred () {
      let postData = {
        'channelId': this.postChannel,
        'classification': this.postKind,
        'dateType': this.postTime,
        'indexId': [this.postQuota],
        'date': this.calendarData || '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      var obj = null
      if (this.TopHundredData === 2) {
        obj = postAction('/simpapp/Filtrate/getTopHundredList', postData)
      } else {
        obj = postAction('/performance/Filtrate/getList', postData)
      }
      obj.then(this.getFilterData)
    },
    clearSelectedBranchs () {
      this.showText = '' // 清空城市名称回显
      this.textShow = false
      this.activeName = ''
      this.reachObj = {
        reachMin: '',
        reachMax: ''
      }
      this.compareObj = {
        compareMin: '',
        compareMax: ''
      }
      this.rateObj = {
        rateMin: '',
        rateMax: ''
      }
      this.ratioObj = {
        ratioMin: '',
        ratioMax: ''
      }
      this.$refs.treeSelect.clearConditions()
    },
    getName (activeNames) {
      this.showText = ''
      if (!this.activeName) {
        this.textShow = false
      } else {
        let firstLevel = Object.values(this.$refs.treeSelect.selected1)
        let secondLevel = Object.values(this.$refs.treeSelect.selected2)
        if (firstLevel.length > 0) {
          for (let i = 0; i < firstLevel.length; i++) {
            let chooseParent = firstLevel[i].orgCode
            let chooseChild = []
            if (secondLevel.length > 0) {
              for (let j = 0; j < secondLevel.length; j++) {
                if (secondLevel[j].parentId === chooseParent) {
                  chooseChild.push(secondLevel[j])
                }
              }
            }
            this.showText = this.showText + '' + firstLevel[i].orgSname
            if (chooseChild.length > 0) {
              for (let i = 0; i < chooseChild.length; i++) {
                if (i === 0) {
                  this.showText = this.showText + '-' + chooseChild[i].orgSname
                } else {
                  this.showText = this.showText + '、' + chooseChild[i].orgSname
                }
              }
            }
            this.showText = this.showText + ';'
          }
        }
        // for (var i in this.firstLevel) {
        //   let chooseParent = this.firstLevel[i].orgCode
        //   let chooseChild = []
        //   for (var j in this.secondLevel) {
        //     if (this.secondLevel[j].parentId === chooseParent) {
        //       chooseChild.push(this.secondLevel[j])
        //     }
        //   }
        //   if (chooseChild.length > 0) {
        //     this.showText = this.showText + '' + this.firstLevel[i].orgSname
        //     for (let i = 0; i < chooseChild.length; i++) {
        //       if (i === 0) {
        //         this.showText = this.showText + '-' + chooseChild[i].orgSname
        //       } else {
        //         this.showText = this.showText + '、' + chooseChild[i].orgSname
        //       }
        //     }
        //     this.showText = this.showText + ';'
        //   }
        // }
        if (this.showText !== '') {
          this.textShow = true
        }
      }
    },
    childClick () { // 确定提交
      this.$emit('childByValue', this.childValue, this.firstLevel, this.secondLevel, this.reachObj, this.compareObj, this.rateObj, this.ratioObj)
    },
    itemButClick (itemBut) {
      this.$set(itemBut, 'checked', !itemBut.checked)
    },
    closeClick () {
      this.$emit('childByValue', this.childValue)
    },
    getFilterData (data) {
      if (data.data) {
        this.branchs = data.data
      }
    },
    getData1 (data) {
      this.firstLevel = data
    },
    getData2 (data) {
      this.secondLevel = data
    },
    getInitialData () {
      this.TopHundredData = this.$store.state.screens.TopHundred
      this.postChannel = '0101'
      this.postKind = this.$store.state.ope.kind
      this.postTime = this.$store.state.ope.time
      this.postQuota = this.$store.state.ope.quota
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.postQuota,
        channelId: this.postChannel,
        date: this.calendarData || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
      })
      this.changeTopHundred()
    }
  },
  mounted () {
    this.getInitialData()
  },
  watch: {
    TopHundredData: function (newval, oldval) {
      this.TopHundredData = newval
    }
    // getData1 () {
    //   this.$nextTick(() => {
    //   })
    // },
    // getData2 () {
    //   this.$nextTick(() => {
    //   })
    // }
  }
}
</script>

<style lang="stylus" scoped>
.table-screes{
  margin : 0 auto;
  text-align : center;
}
.screes-titel, .screes-titel h2{
  height 0.5rem
  line-height .5rem
}
.screes-warpper{
  text-align : left;
  height: 3rem;
  overflow: hidden;
  overflow-y: scroll;
}
.screes-all span{
  margin-right : .2rem;
}
.screes-city{
  margin-top : .1rem;
  display : flex;
  justify-content : center;
}
.screes-city .van-button{
  flex : 1;
  margin : .01rem;
  font-size : 2vw;
  height : auto;
  line-height : 3;
}
.van-button--normal{
  padding : .01rem;
}
.screes-footer{
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: stretch;
}
.screes-footer>button{
  background-color: #fff;
  flex-grow:1;
  box-sizing: border-box;
  padding:.08rem 0;
}
.screes-footer>button:nth-child(1){
  border-top:1px solid #bfbfbf;
  color:#bfbfbf;
}
.screes-footer>button:nth-child(2){
  border-top:1px solid #3399ff;
  color:#fff;
  background-color: #3399ff;
}
.complete-rate{
  overflow:hidden;
  box-sizing:border-box;

}
.complete-rate>div{
  border:1px solid #f9f9f9;
  width:30%;
  float:left;
  padding:.12rem 0;
  text-align: center;
  margin-left:2.5%;
  margin-bottom:2.5%;
  border-radius:.06rem;
  background-color: #f9f9f9;
  color:#999999;
}
.sliderTick{
  overflow:hidden;
}
.sliderTick>div{
  box-sizing: border-box;
  float:left;
}
.sliderTick>div:last-child{
  float:right;
}
.screes-warpper>>>.el-slider__button{
  width: 25px;
  height: 25px;
  box-shadow: 0px 0px 15px #ddd;
  border: none;
}
.sliderCurrent{
  text-align: center;
  color:#3399ff;
}

.itemBut{
  display : flex;
  justify-content : space-around;
}
.itemBut>button{
  display : block;
  color: #1989fa;
  background-color: #fff;
  border: 1px solid #1989fa;
  padding: 0 0.05rem;
}
// .itemButList{
//   display : block;
//   color: #1989fa;
//   background-color: #fff;
//   border: 1px solid #1989fa;
//   padding: 0 0.2rem;
// }
.itemButListH{
  color: #fff !important;
  background-color: #1989fa !important;
  border-width : 0;
}
.text {
  color:#999;
  font-weight:normal;
  margin:10px 0 8px 0;
  width:100%;
  word-break:break-all;
  text-overflow:ellipsis;//显示为省略号
  display:-webkit-box;//对象作为伸缩盒子模型显示
  -webkit-box-orient:vertical;//设置或检索伸缩盒对象的子元素的排列方式
  -webkit-line-clamp:2;//显示行数## 标题文字 ##
  overflow:hidden;
}
.screes-warpper>>>.van-collapse-item__content {
  padding: 0!important;
}
.inputBox>>>.van-collapse-item__wrapper .van-collapse-item__content{
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-cell{
  color: #999!important;
  font-weight:normal
}
.inputBox .van-cell-group{
  display inline-block
  width:30%;
  border:none
}
.van-cell.van-field{
  background-color:#f9f9f9 !important
}
.closeicon {
  position: absolute;
  width:.21rem;
  height:.2rem
  top: 15px;
  right: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/screens/ScreensOpe.vue